import type { Virtualizer } from "@tanstack/react-virtual";
import { useEffect } from "react";
import type { Option } from "../../common/SelectBase";

interface UseVirtualAutoMeasureParams {
  /**
   * Whether the popover is open.
   */
  isPopoverOpen: boolean;
  /**
   * The virtualizer instance.
   */
  virtualizer: Virtualizer<HTMLDivElement, Element>;
  /**
   * The currently filtered options.
   */
  filteredOptions: Option[];
}

/**
 * Hook to calculate and update the virtual list height when the popover is opened.
 */
export function useVirtualListAutoMeasure({
  isPopoverOpen,
  virtualizer,
  filteredOptions
}: UseVirtualAutoMeasureParams) {
  useEffect(() => {
    let cancelled = false;

    if (!isPopoverOpen) {
      return;
    } else {
      requestAnimationFrame(() => {
        if (cancelled) return;

        virtualizer.measure();
        if (
          virtualizer.getVirtualItems().length === 0 &&
          filteredOptions.length > 0
        ) {
          virtualizer.scrollToIndex(0, { align: "start" });
        }
      });
    }
    return () => {
      cancelled = true;
    };
  }, [isPopoverOpen, filteredOptions.length, virtualizer]);
}
